module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "用户注册",
      "center": true,
      "visible": _vm.regVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.regVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "add-body"
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "add-body-form",
    attrs: {
      "model": _vm.submitData,
      "rules": _vm.validatorRules,
      "label-width": "200px"
    }
  }, [_c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-用户名",
      "maxlength": "10",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.submitData.userName),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "userName", $$v)
      },
      expression: "submitData.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-密码",
      "type": "password",
      "maxlength": "10",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.submitData.password),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "password", $$v)
      },
      expression: "submitData.password"
    }
  })], 1)], 1)]), _vm._v(" "), (false) ? _c('el-divider', {
    attrs: {
      "content-position": "center"
    }
  }, [_vm._v("上传图片")]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "图片信息:"
    }
  }, [_c('div', {
    staticClass: "upload-item-view"
  }, [_c('UploadImg', {
    ref: "uploadFile",
    staticClass: "upload-item",
    attrs: {
      "uploadApi": _vm.uploadUrl,
      "fileList": _vm.submitData.attachList,
      "limit": 10,
      "headers": _vm.uploadHeaders
    },
    on: {
      "subBack": _vm.uploadAttachSuccess,
      "handleFileDelete": _vm.uploadAttachDelete
    }
  })], 1)])], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提 交")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f6fe2c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f6fe2c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/main/RegisterView.vue
// module id = 1273
// module chunks = 1